module.exports = __webpack_public_path__ + "img/logo.57a8fc61.svg";